import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { ManageGroupsComponent } from './manage-groups.component';

export const ManageGroups = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageGroupsComponent as any
) as unknown as typeof ManageGroupsComponent;
